class PlacesService {
	constructor(map) {
		this.autocomplete_service = new google.maps.places.AutocompleteService();
		this.places_service = new google.maps.places.PlacesService(map);
	}
	
	_validateSession() {
		if (!this.session) {
			this.session = new google.maps.places.AutocompleteSessionToken();
		}
	}
	
	findPlace(query) {
		return new Promise(resolve => {
			this._validateSession();
			
			const request = {
				input: query,
				sessionToken: this.session,
			};
			
			this.autocomplete_service.getPlacePredictions(request, (results, status) => {
				let final_results = [];
				if (status === google.maps.places.PlacesServiceStatus.OK) {
					final_results = results.map((item) => (
						{
							description: item.description,
							id: item.place_id,
						}
					));
				}
				
				resolve(final_results);
			});
		});
	}

	geoCoding(coord) {

		return new Promise(resolve => {
			this._validateSession();

			var geocoder = new google.maps.Geocoder();

			var latlng = {
				lat: parseFloat(coord.lat()),
				lng: parseFloat(coord.lng())
			};

			geocoder.geocode({
				'location': latlng
			}, function (results, status) {
				if (status === google.maps.GeocoderStatus.OK) {
					if (results[0]) {
						resolve(results[0].place_id)
					}
				}
			})
		})
	}

	getPlaceDetails(place_id) {
		return new Promise(resolve => {
			this._validateSession();
			
			const request = {
				placeId: place_id,
				fields: ['formatted_address', 'geometry'],
				sessionToken: this.session,
			};
			
			this.session = null;
			
			this.places_service.getDetails(request, (place, status) => {
				let final_results = null;
				
				if (status === google.maps.places.PlacesServiceStatus.OK) {
					final_results = {
						address: place.formatted_address,
						lat: place.geometry.location.lat(),
						lng: place.geometry.location.lng(),
					};
				}
				
				resolve(final_results);
			});
		});
	}
}

let instance = null;

export default (map) => {
	if (!instance) {
		instance = new PlacesService(map);
	}
	
	return instance;
};
